import { CLOSE_POPUP_ENRICH_DATA_CODE, SHOW_POPUP_ENRICH_DATA_CODE } from '../Constants'
import sendTrackingData from './sendTrackingData'

export const closePopup = (node_uuid, cb) => {
  // let count = parseInt(localStorage.getItem(`minigame-${node_uuid}`))
  // if (!count) count = 1
  // else count = count + 1
  // localStorage.setItem(`minigame-${node_uuid}`, count)
  sendTrackingData(CLOSE_POPUP_ENRICH_DATA_CODE, { node_uuid })
  cb()
}

export const showPopup = (node_uuid) => {
  sendTrackingData(SHOW_POPUP_ENRICH_DATA_CODE, { node_uuid })
}
